export const convertMarkdownToHTML = (text: string): string => {
	let html = text;

	// Headings
	html = html.replace(/^###### (.+)$/gm, '<h6>$1</h6>');
	html = html.replace(/^##### (.+)$/gm, '<h5>$1</h5>');
	html = html.replace(/^#### (.+)$/gm, '<h4>$1</h4>');
	html = html.replace(/^### (.+)$/gm, '<h3>$1</h3>');
	html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');
	html = html.replace(/^# (.+)$/gm, '<h1>$1</h1>');

	// Bold, Italic, Inline Code
	html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
	html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
	html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

	// Links and Images
	html = html.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" />');
	html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

	// Blockquote, Horizontal Rule
	html = html.replace(/^> (.+)$/gm, '<blockquote>$1</blockquote>');
	html = html.replace(/^---$/gm, '<hr />');

	// Unordered list items
	html = html.replace(/^\* (.+)$/gm, '<li>$1</li>');
	html = html.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>'); // wrap in <ul>

	return html;
	// return text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
}